import { observer } from "mobx-react-lite"

import type { WithdrawStore } from "@/domains/lock-page/withdraw-store"
import { BodyXs } from "@/domains/design/components/body-xs"
import { cn } from "@/domains/library/cn"
import { withdrawStepMap } from "@/domains/lock-page/components/card/withdraw-card/composables/withdraw-steps/withdraw-step-map"
import { ZapCompleted } from "@/domains/minimal-pools-zap/components/zap/composables/zap-icons/zap-completed"
import { ZapFailed } from "@/domains/minimal-pools-zap/components/zap/composables/zap-icons/zap-failed"
import { ZapOnChainAction } from "@/domains/minimal-pools-zap/components/zap/composables/zap-icons/zap-on-chain-action"
import { ZapSpinner } from "@/domains/minimal-pools-zap/components/zap/composables/zap-icons/zap-spinner"

interface WithdrawProgressIndicatorProps {
  store: WithdrawStore
  className?: string
}

export const WithdrawProgressIndicator = observer(({ store, className }: WithdrawProgressIndicatorProps) => {
  const steps = withdrawStepMap[store.state]

  return (
    <ul className={cn("steps w-full self-center", className)}>
      {steps.map((step) => (
        <li key={step.key} className={step.className} data-content={step.dataContent}>
          {step.customIcon === "spinner" ? <ZapSpinner /> : null}
          {step.customIcon === "completed" ? <ZapCompleted /> : null}
          {step.customIcon === "failed" ? <ZapFailed /> : null}
          {step.customIcon === "onchain-action" ? <ZapOnChainAction /> : null}
          <BodyXs> {step.title}</BodyXs>
        </li>
      ))}
    </ul>
  )
})
